/**
 * Career progression levels for medical professionals
 * Represents the hierarchical advancement in medical careers
 */
export enum CareerProgression {
  SPECIALIST = "specialist",
  CONSULTANT = "consultant",
}

/**
 * Array of all career progression values for easy iteration
 */
export const CAREER_PROGRESSION_VALUES = Object.values(CareerProgression);

/**
 * Human-readable labels for career progression levels
 */
export const CAREER_PROGRESSION_LABELS: Record<CareerProgression, string> = {
  [CareerProgression.SPECIALIST]: "Specialist", 
  [CareerProgression.CONSULTANT]: "Consultant",
};